import { Modal, ModalId, O, useUIActions } from '../../../../../features/ui'

type Props = {
    province: O<string>
    onSubmit: () => void
}

export const RemoveIIBBProvinceModal = ({ province, onSubmit }: Props) => {
    const { closeModal } = useUIActions()

    return (
        <Modal
            modalId={ModalId.REMOVE_IIBB_PROVINCE}
            title="Eliminar provincia?"
            submitLabel="Confirmar"
            submitKind="secondary"
            onSubmit={onSubmit}
            onCancel={() => closeModal(ModalId.REMOVE_IIBB_PROVINCE)}
        >
            <>Al eliminar {province}, la empresa dejará de actuar como agente de percepción en esa provincia.</>
        </Modal>
    )
}
